import React from 'react';

interface UserSettingsContextType {
  selectedUser?: UserManagement.PendingUser | UserManagement.SignedUpUser;
  users: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  isLoading: boolean;
  isSsoAccount: boolean;
  isLoadingIsSsoAccount: boolean;
}

const UsersSettingsContext = React.createContext<UserSettingsContextType>({
  users: [],
  isLoading: true,
  isSsoAccount: false,
  isLoadingIsSsoAccount: false,
});

export default UsersSettingsContext;
